"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = '@keyframes shake{8%,41%{transform:translateX(-10px)}25%,58%{transform:translateX(10px)}75%{transform:translateX(-5px)}92%{transform:translateX(5px)}0%,100%{transform:translateX(0)}}';